// Tombol "Pilih dari campaign" di pemilih tujuan. Campaign = grup lintas platform (2026-10-14):
// channel YouTube, akun TikTok, dan akun Instagram, sesuai platform yang dipilih di halaman Campaign.
// Klik = centang persis anggota campaign itu di platform yang sedang dipakai konten ini.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors } from '../theme';

const API = process.env.REACT_APP_API_URL || 'https://api.starhubcreative.id';
const sama = (a, b) => { const s = new Set(a || []); return (b || []).length === s.size && (b || []).every(x => s.has(x)); };

/** Campaign yang isinya sama persis dengan centangan channel YouTube (dipakai UGC). */
export function matchCampaign(groups, selectedIds) {
  return (groups || []).find(g => g.channel_ids.length && sama(selectedIds, g.channel_ids)) || null;
}

/** Campaign multi-platform yang cocok dengan centangan sekarang. sel = {yt, tt, ig} (array id),
 *  aktif = platform yang dipakai konten ini. Cocok bila setiap platform campaign yang aktif sama persis. */
export function matchCampaignMulti(groups, sel, aktif) {
  return (groups || []).find(g => {
    const pl = (g.platforms || ['youtube']).filter(p => aktif[p]);
    if (!pl.length) return false;
    // sel[x] null = pilihan bawaan (semua) yang belum disentuh pengguna -> bukan pilihan campaign,
    // supaya campaign yang kebetulan berisi semua akun tidak tampil "terpilih" sejak awal.
    return pl.every(p => { const v = sel[p === 'youtube' ? 'yt' : p === 'tiktok' ? 'tt' : 'ig'];
      return v != null && sama(v, p === 'youtube' ? g.channel_ids : p === 'tiktok' ? g.tiktok_ids : g.ig_ids); });
  }) || null;
}

/**
 * Mode lama (UGC): props channels/selected/onPick(ids, group) — hanya channel YouTube.
 * Mode multi (upload Shorts): tambah props multi = { ttAccounts, igAccounts, sel: {yt,tt,ig}, aktif: {youtube,tiktok,instagram} };
 * onPick(ids, group) tetap dipanggil, group membawa tiktok_ids & ig_ids juga. Batal pilih:
 * onPick([], null, groupYangDibatalkan) supaya hanya platform campaign itu yang dikosongkan.
 */
export default function CampaignPicker({ channels, selected, onPick, onGroups, multi }) {
  const [raw, setRaw] = useState([]);
  useEffect(() => {
    axios.get(`${API}/api/campaigns/groups`).then(r => setRaw(r.data || [])).catch(() => {});
  }, [channels && channels.length]); // eslint-disable-line

  const activeYt = new Set((channels || []).map(c => c.id));
  const activeTt = new Set(((multi && multi.ttAccounts) || []).map(a => a.id));
  const activeIg = new Set(((multi && multi.igAccounts) || []).map(a => a.id));
  const groups = raw.map(x => ({ ...x,
    platforms: x.platforms || ['youtube'],
    channel_ids: (x.channel_ids || []).filter(id => activeYt.has(id)),
    tiktok_ids: (x.tiktok_ids || []).filter(id => activeTt.has(id)),
    ig_ids: (x.ig_ids || []).filter(id => activeIg.has(id)),
  })).filter(x => multi
    ? (multi.aktif.youtube && x.channel_ids.length) || (multi.aktif.tiktok && x.tiktok_ids.length) || (multi.aktif.instagram && x.ig_ids.length)
    : x.channel_ids.length);

  useEffect(() => { onGroups && onGroups(groups); }, [JSON.stringify(groups.map(g => [g.id, g.channel_ids.length, g.tiktok_ids.length, g.ig_ids.length]))]); // eslint-disable-line
  if (!groups.length) return null;
  const current = multi ? matchCampaignMulti(groups, multi.sel, multi.aktif) : matchCampaign(groups, selected);
  const label = g => {
    if (!multi) return `${g.name} (${g.channel_ids.length})`;
    const part = [multi.aktif.youtube && g.channel_ids.length && `YT ${g.channel_ids.length}`, multi.aktif.tiktok && g.tiktok_ids.length && `TT ${g.tiktok_ids.length}`,
      multi.aktif.instagram && g.ig_ids.length && `IG ${g.ig_ids.length}`].filter(Boolean);
    return `${g.name} (${part.join(' · ')})`;
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', margin: '0 0 10px', padding: '8px 10px', background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 10 }}>
      <span style={{ fontSize: 12, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 4 }}><i className="ti ti-rocket" style={{ fontSize: 14 }}></i>Pilih dari campaign:</span>
      {groups.map(g => {
        const on = current && current.id === g.id;
        return (
          <span key={g.id} onClick={() => (on ? onPick([], null, g) : onPick(g.channel_ids, g))}
            title={on ? 'Klik lagi untuk membatalkan pilihan campaign ini' : 'Centang semua anggota campaign ini'}
            style={{ fontSize: 12.5, fontWeight: 600, padding: '6px 12px', borderRadius: 999, cursor: 'pointer', whiteSpace: 'nowrap',
              border: `1.5px solid ${on ? colors.accent : colors.borderStrong}`, background: on ? colors.accentMuted : colors.bgCard, color: on ? colors.accentText : colors.textPrimary }}>
            {on ? '✓ ' : ''}{label(g)}{on ? ' ✕' : ''}
          </span>
        );
      })}
    </div>
  );
}
